import { z } from 'zod'

/** Shared Zod shapes for recent-items localStorage validation. */
export const documentTableRowSchema = z
  .object({
    id: z.string().min(1),
    // Optional on read so pre-BQ-nav recents still parse; defaulted below.
    systemEntryId: z.string().min(1).optional(),
    title: z.string(),
    filename: z.string(),
    documentTitle: z.string().nullable(),
    system: z.string().nullable(),
    vendor: z.string().nullable(),
    docType: z.string().nullable(),
    fileType: z.string().nullable().optional(),
    drawing: z.string().nullable(),
    sheetNumber: z.string().nullable().optional(),
    timestamp: z.string().nullable(),
    numPages: z.number().nullable(),
    revisionCode: z.string().nullable(),
    revisionDate: z.string().nullable(),
    summary: z.string().nullable(),
    keywords: z.array(z.string()),
    bqDocumentId: z.string().optional(),
    cantileverDocumentEntryId: z.string().optional(),
    cantileverDocumentId: z.string().optional(),
  })
  .transform((row) => {
    const { cantileverDocumentId, ...rest } = row
    return {
      ...rest,
      // Legacy rows used entry UUID as `id` and had no systemEntryId.
      systemEntryId: row.systemEntryId ?? row.id,
      fileType: row.fileType ?? null,
      cantileverDocumentEntryId:
        row.cantileverDocumentEntryId ?? cantileverDocumentId,
    }
  })

const baseSearchableItemFields = {
  id: z.string().min(1),
  displayName: z.string(),
  description: z.string().optional(),
  timestamp: z.string().optional(),
}

export const documentSearchItemSchema = z.object({
  ...baseSearchableItemFields,
  itemType: z.literal('document'),
  documentData: documentTableRowSchema,
})

export const sensorSearchItemSchema = z.object({
  ...baseSearchableItemFields,
  itemType: z.literal('sensor'),
  sensorId: z.string().min(1),
  unit: z.string().optional(),
  asset: z.string().optional(),
  name: z.string(),
})

export const assetSearchItemSchema = z.object({
  ...baseSearchableItemFields,
  itemType: z.literal('asset'),
  name: z.string(),
  assetType: z.string().optional(),
  hasLinkedDatapoints: z.boolean(),
  linkedDatapointIds: z.array(z.string()),
  linkedDocumentIds: z.array(z.string()),
  linkedDocumentCount: z.number(),
})

export const chartSearchItemSchema = z.object({
  ...baseSearchableItemFields,
  itemType: z.literal('chart'),
  name: z.string(),
  sensorIds: z.array(z.string()),
})

export const searchableItemSchema = z.discriminatedUnion('itemType', [
  documentSearchItemSchema,
  sensorSearchItemSchema,
  assetSearchItemSchema,
  chartSearchItemSchema,
])
